export default {
  list: [],
  all: [],
  total: 0,
  totalPages: 0,
  currentPage: 1,
  queries: {},
};
